import { useEffect, useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import { Container } from '@mui/material';

import { IReportRegistration } from "../../../types/report";

import { AppConfig } from "../../../config/appConfig";
import { useUserContext } from "../../../contexts/userContext";
import { ReportService } from "../../../services/reportService";

import PermissionGate from "../../permissionGate";
import Navigation from "../../header";
import { Icons } from "../../icons";
import ReportRegistrationDetailsForm from "../../forms/reportRegistrationDetailsForm";
import Spinner from "../../spinner";


const ReportRegistrationEdit = () => {
	const userContext = useUserContext();

	const { id } = useParams();
	const [registration, setRegistration] = useState<IReportRegistration | undefined>(undefined);
	const [isLoadingRegistration, setIsLoadingRegistration] = useState<boolean>(true);
	const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);

	useEffect(() => {
		loadRegistration();
	}, [id]);

	const loadRegistration = async () => {
		setIsLoadingRegistration(true);
		setErrorMessage(undefined);

		ReportService.getReportRegistration(id)
			.then((response) => {
				console.log('ReportService.getReportRegistration: SUCCESS', response);
				setRegistration(ReportService.mapReportRegistration(response.data));
			})
			.catch((error) => {
				console.log('ReportService.getReportRegistrations: ERROR', error);
				if (error?.code == "ERR_NETWORK") {
					setErrorMessage(AppConfig.apiConnectionErrorMessage)
				}
			})
			.finally(() => {
				setIsLoadingRegistration(false);
			});
	}

	return (
		<div className="hwi-report-registration-add">
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<PermissionGate permission={userContext.permissions?.canManageReportRegistrations}>
					<Spinner dependency={isLoadingRegistration} text="Loading registration...">
						<section className="management-page-header">
							<div className="title">
								<NavLink to="/report/registration">
									<Icons.GoBack fill="#9399ad" height="24px"></Icons.GoBack>
								</NavLink>
								{registration?.displayName}
							</div>
						</section>
						<section className="management-page-form">
							<ReportRegistrationDetailsForm action="edit" id={id} details={registration}></ReportRegistrationDetailsForm>
						</section>
					</Spinner>
				</PermissionGate>
			</Container>
		</div>
	);
};

export default ReportRegistrationEdit;